import { render } from "./CategoryItemComponent.vue?vue&type=template&id=fdef02e0&scoped=true"
import script from "./CategoryItemComponent.vue?vue&type=script&lang=js"
export * from "./CategoryItemComponent.vue?vue&type=script&lang=js"

import "./CategoryItemComponent.vue?vue&type=style&index=0&id=fdef02e0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdef02e0"]])

export default __exports__